import React from 'react';
import PaginationsContainer from '../../Componant/Bonus-Ui/Pagination';

const Paginations = () => {
  return (
    <div className='page-body'>
      <PaginationsContainer />
    </div>
  );
};

export default Paginations;
